import { render, staticRenderFns } from "./AdminConfig.vue?vue&type=template&id=5e69dab8&scoped=true"
import script from "./AdminConfig.vue?vue&type=script&lang=js"
export * from "./AdminConfig.vue?vue&type=script&lang=js"
import style0 from "./AdminConfig.vue?vue&type=style&index=0&id=5e69dab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e69dab8",
  null
  
)

export default component.exports